import unfetch from 'unfetch';
var fetch = unfetch;
if (typeof window !== 'undefined') {
    fetch = window.fetch || unfetch;
}
export default function () {
    function dispatch(url, body) {
        return fetch(url, {
            headers: { 'Content-Type': 'text/plain' },
            method: 'post',
            body: JSON.stringify(body),
        });
    }
    return {
        dispatch: dispatch,
    };
}
//# sourceMappingURL=fetch-dispatcher.js.map